/**
 * Pre-Checkout Upsell Popup (H12)
 *
 * Fängt den Checkout-Klick im Cart-Drawer und auf /cart ab, zeigt ein Popup
 * mit complementary_products-Empfehlungen, die noch nicht im Warenkorb sind.
 *
 * Daten liest es aus <script id="cart-upsell-data"> (per snippet/pre-checkout-upsell.liquid
 * gerendert) und holt Produkt-Details per /products/{handle}.js.
 *
 * Verwendet BekateqCart.add(...) (assets/bekateq-cart.js) für ATC-Aktionen,
 * damit Cart-Drawer + Bubble konsistent aktualisieren.
 */
(function () {
  'use strict';

  var SESSION_KEY = 'bekateq_pcu_count';
  var MAX_SHOWS = 2; // Popup darf bis zu 2x pro Browser-Session erscheinen
  var MAX_RECOMMENDATIONS = 4;
  // Debug-Flag: aktivierbar via ?pcu_debug=1 oder localStorage.setItem('pcu_debug','1')
  var DEBUG =
    /[?&]pcu_debug=1\b/.test(window.location.search) ||
    (function () { try { return localStorage.getItem('pcu_debug') === '1'; } catch (e) { return false; } });
  function log() { if (!DEBUG) return; try { console.log.apply(console, ['[PCU]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {} }

  window.bekateq_pcu_loaded = true;
  log('Script loaded. Debug aktiv. URL:', window.location.href);

  // Elemente werden bei jedem Klick frisch gesucht — Cart-Drawer kann via
  // Section Rendering API nach Add-to-Cart neu in den DOM kommen.
  function getOverlay() { return document.getElementById('pre-checkout-upsell-overlay'); }
  function getDataEl()  { return document.getElementById('cart-upsell-data'); }

  // Wie oft wurde das Popup in dieser Session schon gezeigt?
  function pcuCount() { try { return parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10) || 0; } catch (e) { return 0; } }
  function pcuReachedLimit() { return pcuCount() >= MAX_SHOWS; }

  var pendingCheckoutUrl = '/checkout';
  var isProcessing = false;
  var overlayHandlersAttached = false;

  function fmtMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function loadData() {
    var el = getDataEl();
    if (!el) { log('loadData: cart-upsell-data fehlt im DOM'); return null; }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[PCU] Fehler beim Parsen von cart-upsell-data:', e);
      return null;
    }
  }

  function pickRecommendations(data) {
    if (!data || !Array.isArray(data.upsell_handles)) return [];
    var cartSet = new Set(data.cart_handles || []);
    // Häufigkeit der Empfehlungen — wenn 3 Cart-Items dasselbe Produkt empfehlen, hoch ranken
    var counts = {};
    data.upsell_handles.forEach(function (h) {
      if (!h || cartSet.has(h)) return;
      counts[h] = (counts[h] || 0) + 1;
    });
    var unique = Object.keys(counts).sort(function (a, b) {
      return counts[b] - counts[a];
    });
    return unique.slice(0, MAX_RECOMMENDATIONS);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }

  function renderCard(product) {
    /* Kleinste verfügbare Variante als Vorauswahl (zentrale Sortierung),
       Fallback: erste Variante wie bisher */
    var variant = null;
    if (window.BekateqVariants && product.variants && product.variants.length) {
      variant = window.BekateqVariants.smallestAvailable(product.variants);
    }
    if (!variant) variant = product.variants && product.variants[0];
    if (!variant) return null;

    var card = document.createElement('div');
    card.className = 'pcu-card';

    var img = document.createElement('img');
    img.className = 'pcu-card__image';
    img.alt = product.title;
    img.loading = 'lazy';
    img.src = product.featured_image
      ? product.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x120$1')
      : '';
    card.appendChild(img);

    var info = document.createElement('div');
    info.className = 'pcu-card__info';

    var title = document.createElement('a');
    title.className = 'pcu-card__title';
    title.href = '/products/' + product.handle;
    title.textContent = product.title;
    title.style.color = 'inherit';
    title.style.textDecoration = 'none';
    info.appendChild(title);

    var price = document.createElement('div');
    price.className = 'pcu-card__price';
    price.textContent = fmtMoney(variant.price);
    info.appendChild(price);

    /* Varianten-Dropdown, wenn es mehr als eine Variante gibt */
    if (window.BekateqVariants && product.variants && product.variants.length > 1) {
      var sel = window.BekateqVariants.buildSelect(product.variants, {
        className: 'pcu-card__variant',
        formatMoney: fmtMoney,
        selectedId: variant.id,
      });
      sel.style.cssText = 'display:block;width:100%;margin-top:6px;padding:8px 30px 8px 10px;font-size:13px;font-weight:500;border:1.5px solid #b5b5b5;border-radius:8px;background-color:#fff;cursor:pointer;appearance:none;-webkit-appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' viewBox=\'0 0 12 8\'%3E%3Cpath d=\'M1 1l5 5 5-5\' fill=\'none\' stroke=\'%231a1a1a\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 10px center;';
      sel.addEventListener('change', function () {
        var match = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === sel.value) { match = product.variants[i]; break; }
        }
        if (match) {
          variant = match;
          price.textContent = fmtMoney(match.price);
        }
      });
      info.appendChild(sel);
    }

    card.appendChild(info);

    var atc = document.createElement('button');
    atc.type = 'button';
    atc.className = 'pcu-card__atc';
    atc.textContent = 'Hinzufügen';
    atc.addEventListener('click', function () {
      if (atc.classList.contains('is-added')) return;
      atc.disabled = true;
      atc.textContent = '...';

      var doAdd = function () {
        if (window.BekateqCart && typeof window.BekateqCart.add === 'function') {
          return window.BekateqCart.add([{ id: variant.id, quantity: 1 }], null, {
            originalText: 'Hinzufügen',
          });
        }
        // Fallback ohne BekateqCart
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
        }).then(function (r) { return r.json(); });
      };

      doAdd()
        .then(function () {
          atc.classList.add('is-added');
          atc.textContent = '✓ Hinzugefügt';
          atc.disabled = true;
        })
        .catch(function (err) {
          console.warn('[PCU] ATC error:', err);
          atc.disabled = false;
          atc.textContent = 'Fehler — erneut?';
        });
    });
    card.appendChild(atc);

    return card;
  }

  function showOverlay() {
    var ov = getOverlay();
    if (!ov) { log('showOverlay: kein Overlay-Element'); return; }
    ov.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    try { sessionStorage.setItem(SESSION_KEY, String(pcuCount() + 1)); } catch (e) {}
    log('showOverlay: Overlay sichtbar gemacht');
  }

  function hideOverlay() {
    var ov = getOverlay();
    if (ov) ov.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function attachOverlayHandlers() {
    if (overlayHandlersAttached) return;
    var ov = getOverlay();
    if (!ov) return;
    // Overlay-Hintergrund klick → schließen + zur Kasse
    ov.addEventListener('click', function (e) {
      if (e.target === ov) proceedToCheckout();
    });
    // Close-Buttons + Continue
    ov.querySelectorAll('[data-pcu-close]').forEach(function (b) {
      b.addEventListener('click', function () { proceedToCheckout(); });
    });
    var cont = ov.querySelector('[data-pcu-continue]');
    if (cont) cont.addEventListener('click', function () { proceedToCheckout(); });
    overlayHandlersAttached = true;
    log('Overlay-Handler attached');
  }

  function proceedToCheckout() {
    hideOverlay();
    isProcessing = false;
    window.bekateq_pcu_active = false;
    // Kurze Verzögerung damit Cart-Updates (von ATC) Zeit haben durchzulaufen.
    // Wir triggern bekateq:freeship-trigger — der freeship-handler uebernimmt
    // dann die Eligibility-Pruefung + Navigation (FREESHIP-Discount-Param wird
    // angehaengt wenn berechtigt). Falls kein Handler horcht, navigiert der
    // setTimeout-Fallback direkt.
    var url = pendingCheckoutUrl;
    var dispatched = false;
    try {
      dispatched = !document.dispatchEvent(new CustomEvent('bekateq:freeship-trigger', {
        detail: { url: url },
        cancelable: true
      }));
    } catch (e) {}
    setTimeout(function () {
      // Nur navigieren wenn der freeship-handler die Navigation nicht übernommen hat.
      // (Er navigiert via window.location.href = ... innerhalb seiner async-Funktion.)
      // Als Sicherheitsfallback nach 1.5s: wenn wir noch hier sind, selbst navigieren.
      if (window.location.pathname.indexOf('/checkout') === -1) {
        window.location.href = url;
      }
    }, 1500);
  }

  // ESC schließt
  document.addEventListener('keydown', function (e) {
    var ov = getOverlay();
    if (e.key === 'Escape' && ov && !ov.hidden) proceedToCheckout();
  });

  // Submit-Interception via e.submitter (sprachunabhängig, robuster als Form-Action):
  // Der Checkout-Button im Cart-Drawer hat type="submit" und ein form="cart-drawer-form"
  // Attribut, das Form-Action ist aber "/cart" (nicht "/checkout") — Shopify leitet
  // intern auf /checkout um wenn der Submit-Parameter name="checkout" enthält.
  // Daher fangen wir den Submit ab, wenn der Submitter name="checkout" ist.
  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    var isCheckoutSubmit = submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout';
    if (!isCheckoutSubmit) return;

    var ov = getOverlay();
    var overlayVisible = ov && !ov.hidden;
    if (isProcessing || overlayVisible) {
      log('Submit mit name=checkout blockiert (Popup aktiv)', { isProcessing: isProcessing, overlayVisible: overlayVisible });
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
  }, true);

  // Click-Interception auf Checkout-Buttons (capture phase, damit wir vor Standard-Handlern sind)
  document.addEventListener('click', function (e) {
    if (isProcessing) return;

    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    var link = e.target.closest && e.target.closest('a[href*="/checkout"]');
    if (!btn && !link) return;

    // Flag SOFORT synchron setzen — bevor wir Empfehlungen prüfen oder
    // Sessionstorage lesen. Andere Capture-Phase-Listener (z.B. freeship-
    // discount-handler) laufen synchron nach uns und können den Flag dann
    // in ihrem .then() nach await sehen.
    var data = loadData();
    var recommendations = data ? pickRecommendations(data) : [];
    if (recommendations.length > 0) {
      if (!pcuReachedLimit()) {
        window.bekateq_pcu_active = true;
      }
    }
    log('Checkout click intercepted', { btn: !!btn, link: !!link, target: e.target, willShow: window.bekateq_pcu_active === true });

    // Session-Limit erreicht (2x gezeigt) → durchlassen
    if (pcuReachedLimit()) {
      log('Session-Limit erreicht (' + pcuCount() + '/' + MAX_SHOWS + ') → kein Popup, normaler Checkout');
      return;
    }

    var data = loadData();
    if (!data) { log('Daten nicht ladbar → kein Popup'); return; }

    var recommendations = pickRecommendations(data);
    log('Empfehlungen gefunden:', recommendations);
    if (recommendations.length === 0) { log('Keine Empfehlungen → normaler Checkout'); return; }

    isProcessing = true;
    // Globaler Flag damit freeship-discount-handler.liquid seine Click-Capture-
    // Navigation skippt — sonst navigiert er nach ~1-2s zur Kasse trotz Popup.
    window.bekateq_pcu_active = true;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    // URL für späteren Checkout merken (Button submitted Form, Link hat href)
    if (link && link.href) {
      pendingCheckoutUrl = link.href;
    } else {
      pendingCheckoutUrl = '/checkout';
    }

    var ov = getOverlay();
    if (!ov) {
      log('Overlay-Element fehlt im DOM → kein Popup möglich, weiter zur Kasse');
      isProcessing = false;
      window.location.href = pendingCheckoutUrl;
      return;
    }
    attachOverlayHandlers();
    var grid = ov.querySelector('#pcu-grid');
    if (!grid) {
      log('#pcu-grid fehlt → weiter zur Kasse');
      isProcessing = false;
      window.location.href = pendingCheckoutUrl;
      return;
    }

    // Karten async laden
    grid.innerHTML = '<div style="padding:1rem;color:#888;font-size:1.3rem;">Lade Empfehlungen…</div>';
    showOverlay();

    Promise.all(recommendations.map(function (h) {
      return fetchProduct(h).catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = '';
      var valid = products.filter(function (p) { return p && p.available !== false; });
      if (valid.length === 0) {
        // Sicherheits-Fallback: doch keine validen Empfehlungen → direkt durchlassen
        proceedToCheckout();
        return;
      }
      valid.forEach(function (p) {
        var card = renderCard(p);
        if (card) grid.appendChild(card);
      });
    }).catch(function () {
      proceedToCheckout();
    });
  }, true);
})();
